module.exports = __webpack_public_path__ + "img/undraw_for_review_eqxk.a0ed6373.svg";